import { Injectable } from '@angular/core';

import { Observable, from } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AppSW2 } from './app-sw2';

import apiconfig from '../apiconfig';

@Injectable({
  providedIn: 'root'
})
export class LoadAppsSW2Service {

  constructor(
    private http: HttpClient
  ) { }

  public getAppsSW2(idToken, typeApps, username): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    return from(
      this.http.post(apiconfig.endpoint + "/getapps",{ 'typeApps' : typeApps, 'username' : username },httpOptions),
    ).pipe(
      tap(() => console.log("getAppsSW2"))
    );

  } // end method getAppsSW2

  public activateApplSW2(idToken, applId, username): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    return from(
      this.http.post(apiconfig.endpoint + "/applactivate",{ 'applId' : applId, 'username' : username },httpOptions),
    ).pipe(
      tap(() => console.log("activateApplSW2"))
    );

  } // end method activateAppSW2

  public activateSubscriptionFree(idToken, username): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    var input = "{ 'username':'"+username+"' , 'subscriptionType':'free' , 'typeOp':'write' }"

    return from(
      this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'subscription', 'input' : input.replace(/'/g, '"') },httpOptions),
    ).pipe(
      tap(() => console.log("activateSubscriptionFree"))
    );

  } // end method activateSubscriptionFree

  public registerUser(idToken, username, nome, cognomeRagSoc, piva, codFiscale, indirizzo, cap, citta, provincia, nazione, telefono, dest_fe, pec_fe, email): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    var input = "{ 'username':'"+username+"' , 'typeOp':'write', 'nome':'"+nome+"' , 'cognomeRagSoc':'"+cognomeRagSoc+"' , 'piva':'"+piva+"' , 'codFiscale':'"+codFiscale+"' , 'indirizzo':'"+indirizzo+"' , 'cap':'"+cap+"' , 'citta':'"+citta+"' , 'provincia':'"+provincia+"' , 'nazione':'"+nazione+"' , 'telefono':'"+telefono+"' , 'dest_fe':'"+dest_fe+"' , 'pec_fe':'"+pec_fe+"' , 'email':'"+email+"' }"

    return from(
      this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'registration', 'input' : input.replace(/'/g, '"') },httpOptions),
    ).pipe(
      tap(() => console.log("registerUser"))
    );

  } // end method registerUser

}
